// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_xH8","newExpiryDate":"styles_newExpiryDate__1vOq0","footer":"styles_footer__1ou9-"};